import { render, staticRenderFns } from "./cellRenderer.vue?vue&type=template&id=ddc50eb2&scoped=true&"
import script from "./cellRenderer.vue?vue&type=script&lang=js&"
export * from "./cellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc50eb2",
  null
  
)

/* custom blocks */
import block0 from "./cellRenderer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports